import React from "react";
import { ArrayInput, Button, ReferenceInput, SelectInput, SimpleFormIterator, useNotify } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { graduationRequests } from "api/graduationApi";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { settings } from "app";
import { Grid } from "@mui/material";
import dataProvider from "server/dataProvider";

const AssignTrainingBasesDialog = ({ assignedTrainingBases, studentEducationId, fetchAssignedTrainingBases }) => {
  const notify = useNotify();

  const handleSubmit = async data => {
    const payload = { assignments: data.assignments };
    await dataProvider.customRequest(graduationRequests.studentTrainingBases(studentEducationId), payload, "POST");
    notify("Успешно назначаване на учебна база");
    fetchAssignedTrainingBases();
  };

  return (
    <FormModal
      titleContent={"Назначи учебна база за студент"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label="Назначи учебна база"
          variant="contained"
          startIcon={<AssignmentTurnedInIcon />}
          sx={{ ml: 2 }}
        />
      }
    >
      <ArrayInput
        source="assignments"
        label=" "
        defaultValue={assignedTrainingBases && assignedTrainingBases.length > 0 ? assignedTrainingBases : [{}]}
      >
        <SimpleFormIterator
          disableReordering
          inline
          sx={settings.style.iteratorWithoutGap}
        >
          <Grid
            container
            spacing={2}
          >
            <ReferenceInput
              source="trainingBaseId"
              reference={graduationRequests.getStudentTrainingBasesSelect(studentEducationId)}
            >
              <SelectInput
                label="Учебна база"
                optionText={rec => `${rec.buildingName} - ${rec.wardName}`}
                emptyText={false}
              />
            </ReferenceInput>
            <CustomDateInput
              source="fromDate"
              noTime
              label="От дата"
            />
            <CustomDateInput
              source="toDate"
              noTime
              label="До дата"
            />
          </Grid>
        </SimpleFormIterator>
      </ArrayInput>
    </FormModal>
  );
};

export default AssignTrainingBasesDialog;
